// frontend/src/api.js
const DEFAULT_API_BASE = "/api";

export function getApiBase() {
  return process.env.REACT_APP_API_BASE || DEFAULT_API_BASE;
}

async function parseJsonOrThrow(res) {
  const ct = res.headers.get("content-type") || "";
  const text = await res.text();

  if (!ct.includes("application/json")) {
    throw new Error(`Non-JSON response (${res.status}): ${text.slice(0, 120)}...`);
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error(`Invalid JSON (${res.status}): ${text.slice(0, 120)}...`);
  }

  if (!res.ok) {
    const msg = data?.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

/** -------------------------
 * Carrier API
 * ------------------------*/
export async function apiGet(path, { carrierEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = {};
  if (carrierEmail) headers["x-carrier-email"] = carrierEmail;

  const res = await fetch(url, { method: "GET", headers });
  return parseJsonOrThrow(res);
}

export async function apiPost(path, body, { carrierEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = { "Content-Type": "application/json" };
  if (carrierEmail) headers["x-carrier-email"] = carrierEmail;

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body || {}),
  });

  return parseJsonOrThrow(res);
}

/** -------------------------
 * Broker API
 * ------------------------*/
export async function apiGetBroker(path, { adminEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = {};
  if (adminEmail) headers["x-admin-email"] = adminEmail;

  const res = await fetch(url, { method: "GET", headers });
  return parseJsonOrThrow(res);
}

export async function apiPostBroker(path, body, { adminEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = { "Content-Type": "application/json" };
  if (adminEmail) headers["x-admin-email"] = adminEmail;

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body || {}),
  });

  return parseJsonOrThrow(res);
}

export async function apiPatchBroker(path, body, { adminEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = { "Content-Type": "application/json" };
  if (adminEmail) headers["x-admin-email"] = adminEmail;

  const res = await fetch(url, {
    method: "PATCH",
    headers,
    body: JSON.stringify(body || {}),
  });

  return parseJsonOrThrow(res);
}

export async function apiDeleteBroker(path, { adminEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = {};
  if (adminEmail) headers["x-admin-email"] = adminEmail;
  const res = await fetch(url, { method: "DELETE", headers });
  return parseJsonOrThrow(res);
}

/** -------------------------
 * Shipper API (NEW)
 * ------------------------*/
export async function apiGetShipper(path, { shipperEmail, shipperCompanyId } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = {};
  if (shipperEmail) headers["x-shipper-email"] = shipperEmail;
  if (shipperCompanyId) headers["x-shipper-company-id"] = shipperCompanyId;

  const res = await fetch(url, { method: "GET", headers });
  return parseJsonOrThrow(res);
}

export async function apiPostShipper(path, body, { shipperEmail } = {}) {
  const url = `${getApiBase()}${path}`;
  const headers = { "Content-Type": "application/json" };
  if (shipperEmail) headers["x-shipper-email"] = shipperEmail;

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body || {}),
  });

  return parseJsonOrThrow(res);
}

/** -------------------------
 * Auth helpers
 * ------------------------*/
export function getAdminEmail() {
  return localStorage.getItem("adminEmail") || "admin@roadoptix.com";
}

export function getCarrierEmail() {
  return localStorage.getItem("carrierEmail") || "dispatch@bestcarrier.com";
}

export function getShipperEmail() {
  return localStorage.getItem("shipperEmail") || "";
}
